import type React from 'react';
import type { SectionVariable } from '../types/settings';
import { BrandHeader } from './common/BrandHeader';
import { BrandFooter } from './common/BrandFooter';
import { SecureFooter } from './common/SecureFooter';
import { LineValidation } from './home/LineValidation';
import { PlanList } from './plans/PlanList';
import { CreditCardCheckout } from './card/CreditCardCheckout';
import { LegacyPayment } from './legacy/LegacyPayment';

/**
 * Catálogo de componentes registráveis.
 *
 * Todo componente referenciado por `component` no `settings.json` PRECISA estar
 * aqui. É o único ponto de resolução de string → componente (ver
 * `src/layouts/structure/SectionItem.tsx`).
 *
 * Checklist para adicionar um componente novo:
 * 1. criar o arquivo em `src/components/<área>/`;
 * 2. registrar aqui;
 * 3. documentar em `docs/rendering/layout-and-components.md`;
 * 4. usar `useTranslation()` em toda string visível.
 */

export interface ComponentProps {
  /** Parâmetros posicionais vindos do settings.json. */
  variables?: SectionVariable;
  /** Nome do item na seção — útil para depuração e testes. */
  name?: string;
}

export const componentCatalog: Record<string, React.ComponentType<ComponentProps>> = {
  BrandHeader,
  BrandFooter,
  SecureFooter,
  LineValidation,
  PlanList,
  CreditCardCheckout,
  LegacyPayment,
};

export { BrandHeader, BrandFooter, SecureFooter, LineValidation, PlanList, CreditCardCheckout, LegacyPayment };
